<template>
	<div class=" enterprisewebsite oh"  v-title :data-title="msg">
		<headerbar :curindex="curindex" v-if="userdata.userType >1"></headerbar>
		<leftnav class=" fl" :curindex="11"   :activenav='"1-4"' v-if="userdata.userType==1"></leftnav> 
		<div class=" " :class="userdata.userType ==1?'index_left':'pagecontent indexcenterpage'">
			<govheader v-if="userdata.userType==1"></govheader>
				<div :class="userdata.userType ==1?'index_left_centerpage':''">
	 <div class="industrial-list " :class="userdata.userType ==1?'gov_industrial_list':''">
			<div class="whitebox centerpage oh">
				<div class="w95mg">
					<div class="floortitle-en">
						<div class="right_boxtitle" v-if="userdata.userType==1">
							<span class="fl right_title">宏观动态</span>
								<div class="fr">
									<input type="text" placeholder="2022-1-2" class="" />
									<button class="" >查询</button>
								</div>
						</div>
						<h2 class="title" v-if="userdata.userType>1">宏观动态</h2>
						<div class="list-tabtitle oh">
							<h5 class="fwn fl title">日期</h5>
							<div class="fl tabtitle-b">
								<span :class="dynamicdate == item?'tabdate current':'tabdate'"  v-for="item in pagedata.dateList" @click="getmacordynamiclist(item)">{{item}}</span> 
								</div> 
						</div>
					</div>
					<div class="indexflex dynamiclist-ind">
						<div class="col4h">
							<h4 class="title">利好动态</h4>
							<ul>
								<li v-for="list in goodnews" :data="list.id" @click="routerlinkid('/news',list.id,1)">
									<h5 class="fwn onlyline fl a-router" >{{list.title}}</h5>
									<span class="stargrade1 fr redstargrade"><i v-for="item in list.star"></i></span>
								</li>
							</ul>
							<span class="morelink">更多内容>></span>
						</div>
						<div class="col4h">
							<h4 class="title">利空动态</h4>
							<ul>
								<li v-for="list in badnews" :data="list.id" @click="routerlinkid('/news',list.id,1)">
									<h5 class="fwn onlyline fl a-router" >{{list.title}}</h5>
									<span class="stargrade1 fr greenstargrade"><i v-for="item in list.star"></i></span>
								</li>
							</ul>
							<span class="morelink">更多内容>></span>
						</div> 
					</div>  
				</div>
			</div>
			 <div class="whitebox centerpage oh">
				<div class="w95mg">
					<div class="floortitle-en mgbn">
						
						<div class="right_boxtitle" v-if="userdata.userType==1">
							<span class="fl right_title">宏观大事件</span> 
						</div>
						
						<h2 class="title" v-if="userdata.userType>1">宏观大事件</h2> 
					</div>
					<div class="indexflex macro_eventlist">
						<div class="col4h col4hl dynamiclist-ind ">
							 <div class="titlebox oh"><span class="fl name name1">事件</span><span class="stargrade1 fr">影响程度</span></div>
								<ul class="">
									<li class="oh" v-for="item in pagedata.latestEvent" @click="routerlinkid('/newsTopics',item.id,item.bigClass)"><span class="fl onlyline a-router">{{item.title}}</span>
										<p class="stargrade1 stargrade fr"><i class="starfull" v-for="star in item.star"></i><i class="stargray" v-for="star in (5-item.star)"></i></p>
									</li>
								</ul>
								<span class="morelink">更多内容>></span>
						</div>
						<div class="col4h macro-tips">
							 <div class="titlebox">
									<h5 :class="toipsbtn == 1?'fl':'fl nocur'" @click="toipsbtn=1">机会提示</h5>
									<h5 :class="toipsbtn == 2?'fl':'fl nocur'" @click="toipsbtn=2">风险提示</h5></div>
								<ul v-show="toipsbtn == 1">
									<li v-for="item in pagedata.goodEvent "><span class="onlyline db a-router" @click="routerlinkid('/newsTopics',item.id,item.bigClass)">{{item.title}}</span></li>
								</ul>
									<ul v-show="toipsbtn == 2">
										<li v-for="item in pagedata.badEvent " class=""><span class="onlyline db" @click="routerlinkid('/newsTopics',item.id,item.bigClass)">{{item.title}}</span></li>
									</ul> 
								<span class="morelink">更多内容>></span>
						</div> 
					</div>  
				</div>
			</div> 
			<div class="whitebox centerpage oh">
				<div class="w95mg">
					<div class="floortitle-en bdbe">
						<h2 class="title" v-if="userdata.userType>1"><strong>P</strong><i>一</i><span>政治政策环境分析</span></h2>
						<div class="right_boxtitle" v-if="userdata.userType==1">
						<span class="fl right_title"> <strong>P</strong><i>一</i><span>政治政策环境分析</span> </span> 
					</div>
					</div> 
					
					<div class="indexflex dynamiclist-ind">
						<div class="col4h">
							<h4 class="title">有利因素</h4>
							<ul>
								<li v-for="list in pagedata.pest[0].goodP" :data="list.id" @click="routerlinkid('/newsTopics',list.id,list.bigClass)">
									<h5 class="fwn onlyline fl a-router" >{{list.title}}</h5>
									<span class="stargrade1 fr redstargrade"><i v-for="item in list.star"></i></span>
								</li>
							</ul>
							<span class="morelink">更多内容>></span>
						</div>
						<div class="col4h">
							<h4 class="title">不利因素</h4>
							<ul>
								<li v-for="list in pagedata.pest[0].badP" :data="list.id" @click="routerlinkid('/newsTopics',list.id,list.bigClass)">
									<h5 class="fwn onlyline fl a-router" >{{list.title}}</h5>
									<span class="stargrade1 fr greenstargrade"><i v-for="item in list.star"></i></span>
								</li>
							</ul>
							<span class="morelink">更多内容>></span>
						</div> 
					</div>  
				</div>
			</div>
			<div class="whitebox centerpage oh">
				<div class="w95mg">
					<div class="floortitle-en bdbe">
						<h2 class="title" v-if="userdata.userType>1"><strong>E</strong><i>一</i><span>经济环境分析</span></h2> 
						<div class="right_boxtitle" v-if="userdata.userType==1">
							<span class="fl right_title"> <strong>E</strong><i>一</i><span>经济环境分析</span> </span> 
						</div>
					</div>
					<div class="indexflex dynamiclist-ind">
						<div class="col4h">
							<h4 class="title">有利因素</h4>
							<ul>
								<li v-for="list in pagedata.pest[1].goodE" :data="list.id" @click="routerlinkid('/newsTopics',list.id,list.bigClass)">
									<h5 class="fwn onlyline fl a-router" >{{list.title}}</h5>
									<span class="stargrade1 fr redstargrade"><i v-for="item in list.star"></i></span>
								</li>
							</ul>
							<span class="morelink">更多内容>></span>
						</div>
						<div class="col4h">
							<h4 class="title">不利因素</h4>
							<ul>
								<li v-for="list in pagedata.pest[1].badE" :data="list.id" @click="routerlinkid('/newsTopics',list.id,list.bigClass)">
									<h5 class="fwn onlyline fl a-router" >{{list.title}}</h5>
									<span class="stargrade1 fr greenstargrade"><i v-for="item in list.star"></i></span>
								</li>
							</ul>
							<span class="morelink">更多内容>></span>
						</div> 
					</div>  
				</div>
			</div>
			<div class="whitebox centerpage oh">
				<div class="w95mg">
					<div class="floortitle-en bdbe">
						<h2 class="title" v-if="userdata.userType>1"><strong>S</strong><i>一</i><span>社会与文化分析</span></h2> 
						<div class="right_boxtitle" v-if="userdata.userType==1">
							<span class="fl right_title"> <strong>S</strong><i>一</i><span>社会与文化分析</span> </span> 
						</div>
					</div>
					<div class="indexflex dynamiclist-ind">
						<div class="col4h">
							<h4 class="title">有利因素</h4>
							<ul>
								<li v-for="list in pagedata.pest[2].goodS" :data="list.id" @click="routerlinkid('/newsTopics',list.id,list.bigClass)">
									<h5 class="fwn onlyline fl a-router" >{{list.title}}</h5>
									<span class="stargrade1 fr redstargrade"><i v-for="item in list.star"></i></span>
								</li>
							</ul>
							<span class="morelink">更多内容>></span>
						</div>
						<div class="col4h">
							<h4 class="title">不利因素</h4>
							<ul>
								<li v-for="list in pagedata.pest[2].badS" :data="list.id" @click="routerlinkid('/newsTopics',list.id,list.bigClass)">
									<h5 class="fwn onlyline fl a-router" >{{list.title}}</h5>
									<span class="stargrade1 fr greenstargrade"><i v-for="item in list.star"></i></span>
								</li>
							</ul>
							<span class="morelink">更多内容>></span>
						</div> 
					</div>  
				</div>
			</div>
			<div class="whitebox centerpage oh">
				<div class="w95mg">
					<div class="floortitle-en bdbe">
						<h2 class="title" v-if="userdata.userType>1"><strong>T</strong><i>一</i><span>技术环境分析</span></h2>
							<div class="right_boxtitle" v-if="userdata.userType==1">
								<span class="fl right_title"> <strong>T</strong><i>一</i><span>技术环境分析</span> </span> 
							</div>
					</div>
					<div class="indexflex dynamiclist-ind">
						<div class="col4h">
							<h4 class="title">有利因素</h4>
							<ul>
								<li v-for="list in pagedata.pest[3].goodT" :data="list.id" @click="routerlinkid('/newsTopics',list.id,list.bigClass)">
									<h5 class="fwn onlyline fl a-router" >{{list.title}}</h5>
									<span class="stargrade1 fr redstargrade"><i v-for="item in list.star"></i></span>
								</li>
							</ul>
							<span class="morelink">更多内容>></span>
						</div>
						<div class="col4h">
							<h4 class="title">不利因素</h4>
							<ul>
								<li v-for="list in pagedata.pest[3].badT" :data="list.id" @click="routerlinkid('/newsTopics',list.id,list.bigClass)">
									<h5 class="fwn onlyline fl a-router" >{{list.title}}</h5>
									<span class="stargrade1 fr redstargrade"><i v-for="item in list.star"></i></span>
								</li>
							</ul>
							<span class="morelink">更多内容>></span>
						</div> 
					</div>  
				</div>
			</div>
			<div class="whitebox centerpage oh">
				<div class="w95mg">
					<div class="floortitle-en bdbe oh">
						<h2 class="title  fl" v-if="userdata.userType>1">宏观报告</h2> 
						
						<div class="right_boxtitle" v-if="userdata.userType==1">
							<span class="fl right_title">宏观报告 </span> 
							<div class="fr">
								<input type="text" placeholder="检索报告库" class="" />
								<button class="" >查询</button>
							</div>
						</div>
						
						<a href="" class="fr morelink1">更多内容>></a>
					</div> 
					<ul  class="marc-reportlist">
						<li class="titlebox bdrline"><h5 class="fl date">时间</h5><h5 class="fl name">报告名称</h5></li>
						<li class="titlebox"><h5 class="fl date">时间</h5><h5 class="fl name">报告名称</h5></li>
						<li v-for="(item,i) in pagedata.report" :class="i%2==0?'bdrline':''" @click="macreportclick(item.file,item.id)"><span class="date">{{item.publishTime}}</span><span class="name a-router">{{item.title}}</span></li>
					</ul>  
				</div>
			</div> 
			<!--  -->
		</div> 
		</div>
		</div>
		<footerbar v-if="userdata.userType>1"></footerbar>
	</div>
</template>

<script>
	export default {
	  name: 'macrobgList',
	  data(){return{
				msg:"宏观背景",
				curindex:1,
				toipsbtn:1,
				pagedata:{badEvent:[],badNews:[],dateList:[],goodEvent:[],goodNews:[],latestEvent:[],pest:[{badP:[],goodP:[]},{badE:[],goodE:[]},{badS:[],goodS:[]},{badT:[],goodT:[]}],report:[]},
				goodnews:[],
				badnews:[],
				dynamicdate:'2020202', 
				userdata:{},
			}},
			created() {  
				this.userdata = this.getuseriformation();
				this.getuserinfor();
				this.getpagedata();
			},
			mounted() { 
			},
			methods:{
				//公用部分
				getuserinfor(){
					this.bus.$emit('loading',true);
					let dataddd=sessionStorage.getItem('userData') ? sessionStorage.getItem('userData'):localStorage.getItem('userData') ;
					if(typeof(dataddd) == 'object'){
					this.userdata = dataddd;
					}else{
					this.userdata = JSON.parse(dataddd);
					}  
				},
				getpagedata(){
					var _this=this; 
					this.$axios.get(this.$api.cyl.enterpriseEdition.macrobg(),{headers:{AuthToken:this.userdata.token}}).then(function(res){ 
						console.log(res.data.data) 
						_this.pagedata=res.data.data;
						_this.goodnews=res.data.data.goodNews;
						_this.badnews=res.data.data.badNews; 
						_this.getmacordynamiclist(res.data.data.dateList[0]);
						_this.dynamicdate=res.data.data.dateList[0];
						_this.bus.$emit('loading',false);
					}) ;
				},
				getmacordynamiclist(date){
					var _this=this; 
					this.dynamicdate=date;
					this.$axios.get(this.$api.cyl.news.list()+'?type=1&date='+date,{headers:{AuthToken:this.userdata.token}}).then(function(res){ 
						console.log(res.data.list);
						_this.goodnews=res.data.list.filter(data=>{
							return data.good==1;
						});
						_this.badnews=res.data.list.filter(data=>{
							return data.good==2;
						}); 
					}) ;  
				}, 
				macreportclick(file,id){
					if(file!=""){
						this.routerlinkid('/pdf',id);
					}else{
						this.routerlinkid('/news',id);
					}
				}
				
			}
	}
	
	
	
</script>

<style >
	
</style> 
